import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { TokenService } from './token.service';
import { Authenticate } from '../models/authenticate';
import { User } from '../models/user';
import { map } from 'rxjs';

const TOKEN_URL = siteSpecificData.tokenUrl;

@Injectable()
export class AuthService {

  isAuthenticated() {
    return this.tokenService.getToken() != null;
  }

  resetPassword(email: string) {

  }

  logout() {
    this.tokenService.clearTokens();
    localStorage.removeItem('user');
    localStorage.removeItem('roles');
    localStorage.removeItem('auth');
  }

  login(auth: Authenticate): Observable<User> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const granttype = 'password';
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('grant_type', granttype);
    urlSearchParams.set('client_id', 'MCI');
    urlSearchParams.set('username', auth.username);
    urlSearchParams.set('password', auth.password);
    const body = urlSearchParams.toString();

    const result = this.http.post(TOKEN_URL, body, { headers: headers }).pipe(
      map((res: any) => {
        if (res && res.access_token) {
          localStorage.setItem('auth', JSON.stringify(res));
          this.tokenService.setToken(res.access_token);
          this.tokenService.setRefreshToken(res.refresh_token);
          localStorage.setItem('user', auth.username);
          localStorage.setItem('roles', res.roles);

          return { name: auth.username } as User;
        } else {
          return null as User;
        }
      }));
    return result;
  }

  constructor(private http: HttpClient, private tokenService: TokenService) {
  }
}
